import * as React from 'react';

export const ETLHelper = ({ etl }) => {
  return etl ? (
    <div className="etlHelper">
      *** This case is automatically loaded into the GMCNgine with information we collected from your agency web site. Only certain fields are enabled for editing - if you have any questions please contact
      <a href="mailto:help@gmcngine.com"> help@gmcngine.com</a>
    </div>
  ) : null
}